"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";
import ApiRequest from "@/shared/lib/client-sdk/api-request";

class NextLevelEmailTemplate extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "NextLevelEmailTemplate";
  }

  static getApiPathForSearch() {
    console.error("Cannot execute a search of Email Template.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/next-level-email-templates/" +
      this.id
    );
  }

  getAdminPath() {
    console.error("Cannot go to a Email Template.");
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return this.createdAt;
  }

  get searchResultStatus() {
    return null;
  }

  /**** HELPER ADDITIONS ********/
  async create(accountId) {
    let request =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/accounts/" +
      accountId +
      "/next-level-email-templates";

    let formData = new FormData();
    formData.append("displayName", this.displayName);
    formData.append("storedFile", this.storedFile);

    return new Promise((resolve, reject) => {
      ApiRequest.upload(request, formData).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  async update() {
    let request = this.getApiPathForRefreshUpdateAndDelete();
    let formData = new FormData();
    let attributesToUpdate = this.getDirtyAttributes();

    if (Object.keys(attributesToUpdate).length === 0) return;

    Object.keys(attributesToUpdate).forEach((key) => {
      formData.append(key, attributesToUpdate[key]);
    });

    return new Promise((resolve, reject) => {
      ApiRequest.send("PATCH", request, formData).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }
}

export default NextLevelEmailTemplate;
